import { applySnapshot, getSnapshot, types } from "mobx-state-tree";

export const PasswordStore = types
  .model("PasswordStore", {
    password: types.optional(types.string, ""),
    confirmPassword: types.optional(types.string, ""),
  })
  .views((self) => {
    return {
      get formValues() {
        return getSnapshot(self);
      },
      get completed() {
        return Boolean(self.password && self.confirmPassword);
      },
    };
  })
  .actions((self) => {
    const onFormSubmit = function onFormSubmit(formData: any) {
      let xx: any = getSnapshot(self);
      applySnapshot(self, { ...xx, ...formData });
    };
    return {
      onFormSubmit,
    };
  });
